(function () {
  var root = document.getElementById('vsf-root');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var configNode = document.getElementById('vsf-config');
  if (!configNode) return;

  var runtime;
  try {
    runtime = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    return;
  }

  var defaults = {
    products: {
      heavy_duty: {
        name: 'Heavy Duty Insole',
        kind: 'insole',
        image: '',
        reason: 'Your pattern points to high-load in-shoe support.',
        backup: 'Recovery footwear can help as a second layer after long days.'
      },
      fascia_soothe: {
        name: 'Fascia Soothe Insole',
        kind: 'insole',
        image: '',
        reason: 'Your pattern points to arch and plantar-fascia pressure support.',
        backup: 'Stable daily support can be the balanced backup path.'
      },
      recovery_slide: {
        name: 'Recovery Slide',
        kind: 'footwear',
        image: '',
        reason: 'Your pattern points to hard-floor recovery and low-impact support.',
        backup: 'Heavy Duty Insole can help if closed-shoe pain repeats.'
      },
      propel_flip: {
        name: 'Propel Flip',
        kind: 'footwear',
        image: '',
        reason: 'Your pattern points to recovery support with an easy open-toe fit.',
        backup: 'Heavy Duty Insole can help if closed-shoe pain repeats.'
      },
      compression_max: {
        name: 'Compression Max Socks',
        kind: 'sock',
        image: '',
        reason: 'Your pattern includes heavy legs, travel, or swelling signals.',
        backup: 'Pair with in-shoe support if heel or arch pain stays localized.'
      }
    },
    eligibility: {
      heavy_duty: { genders: ['men', 'women'], fallbackMinMen: 4, fallbackMaxMen: 15 },
      fascia_soothe: { genders: ['men', 'women'] },
      recovery_slide: { genders: ['men'], fallbackMinMen: 5, fallbackMaxMen: 13 },
      propel_flip: { genders: ['men'], fallbackMinMen: 5, fallbackMaxMen: 13 },
      compression_max: { genders: ['men', 'women'], sizeOptional: true }
    },
    matchRules: [
      { priority: 100, match: { load: 'heavy_legs' }, primary: 'compression_max', confidence: 'Strong' },
      { priority: 95, match: { context: 'inside_shoes' }, primary: 'heavy_duty', confidence: 'Strong' },
      { priority: 86, match: { pain: 'arch' }, primary: 'fascia_soothe', confidence: 'Good' },
      { priority: 82, match: { context: 'home' }, primary: 'recovery_slide', confidence: 'Strong' },
      { priority: 72, match: { pain: 'fatigue' }, primary: 'recovery_slide', confidence: 'Good' },
      { priority: 1, match: {}, primary: 'heavy_duty', confidence: 'Medium' }
    ],
    fallbackOrder: ['heavy_duty', 'fascia_soothe', 'recovery_slide', 'propel_flip', 'compression_max']
  };

  var configs = {
    homepage_general: {
      label: 'Homepage version',
      launcher: runtime.launcherLabel || 'Fit quiz → 25% off',
      introTitle: 'Not sure what to pick?',
      introCopy: 'Answer a few quick questions and get matched to the support path that fits your routine.',
      currentProduct: '',
      coupon: runtime.coupon && runtime.coupon.homepage_general ? runtime.coupon.homepage_general : 'VALSOLE25',
      questions: [
        {
          key: 'pain',
          title: 'Where do you feel it most?',
          copy: 'Start with the signal you notice first.',
          options: [
            ['heel', 'Heel', 'Sharp first steps or heel pressure'],
            ['arch', 'Arch', 'Midfoot fatigue or pulling'],
            ['forefoot', 'Ball of foot', 'Forefoot pressure'],
            ['fatigue', 'General fatigue', 'Tired feet or heavy legs'],
            ['unsure', 'Not sure', 'Help me start conservative']
          ]
        },
        {
          key: 'context',
          title: 'Where do you need support first?',
          copy: 'This helps us choose in-shoe structure or recovery footwear.',
          options: [
            ['inside_shoes', 'Inside work shoes', 'Closed-shoe support first'],
            ['walking', 'Walking or daily shoes', 'Daily movement comfort'],
            ['home', 'At home on hard floors', 'Recovery footwear first'],
            ['recovery', 'Recovery after activity', 'Lower-impact support'],
            ['mixed', 'Mixed day to day', 'A flexible support path']
          ]
        },
        {
          key: 'load',
          title: 'How demanding is a typical day?',
          copy: 'Load changes how firm the first recommendation should be.',
          options: [
            ['standing_all_day', 'Standing most of the day', 'Work shifts, concrete, long blocks'],
            ['moderate', 'Moderate walking', 'Errands and daily movement'],
            ['low', 'Mostly home or desk', 'Lower daily impact'],
            ['heavy_legs', 'Travel, swelling, or heavy legs', 'Compression/recovery signal']
          ]
        }
      ]
    },
    pdp_insole: {
      label: 'PDP insole version',
      launcher: 'Fit quiz → 25% off',
      introTitle: 'Not sure what to pick?',
      introCopy: 'Answer a few quick questions and get matched to the support path that fits your routine.',
      currentProduct: root.dataset.productHandle || '',
      coupon: runtime.coupon && runtime.coupon.pdp_insole ? runtime.coupon.pdp_insole : 'VALSOLE25',
      questions: [
        {
          key: 'pain',
          title: 'What pain pattern are you trying to solve?',
          copy: 'For insoles, heel and arch signals matter most.',
          options: [
            ['heel', 'Heel pressure', 'First-step pain or impact under heel'],
            ['arch', 'Arch strain', 'Pulling or fatigue through midfoot'],
            ['mixed', 'Heel + arch', 'Pain moves between both zones'],
            ['forefoot', 'Forefoot pressure', 'Ball-of-foot or metatarsal stress']
          ]
        },
        {
          key: 'context',
          title: 'Where will you wear support?',
          copy: 'Closed-shoe use usually points to an insole-first answer.',
          options: [
            ['inside_shoes', 'Work or closed shoes', 'Most support happens inside shoes'],
            ['walking', 'Walking shoes', 'Daily movement and errands'],
            ['home', 'Mostly at home', 'Barefoot or hard-floor time is the trigger'],
            ['mixed', 'Both shoe and home use', 'Needs a two-layer path']
          ]
        },
        {
          key: 'load',
          title: 'How much load should it handle?',
          copy: 'Higher load needs stronger structure.',
          options: [
            ['standing_all_day', 'Standing most of the day', 'High-load support'],
            ['moderate', 'Moderate daily use', 'Balanced support'],
            ['low', 'Light use', 'Start conservative'],
            ['heavy_legs', 'Heavy legs or swelling', 'May need compression support']
          ]
        }
      ]
    },
    pdp_footwear: {
      label: 'PDP footwear version',
      launcher: 'Fit quiz → 25% off',
      introTitle: 'Not sure what to pick?',
      introCopy: 'Answer a few quick questions and get matched to the support path that fits your routine.',
      currentProduct: root.dataset.productHandle || '',
      coupon: runtime.coupon && runtime.coupon.pdp_footwear ? runtime.coupon.pdp_footwear : 'VALSOLE25',
      questions: [
        {
          key: 'pain',
          title: 'What are you trying to ease first?',
          copy: 'Footwear is strongest when the trigger happens outside closed shoes.',
          options: [
            ['fatigue', 'Tired feet', 'End-of-day soreness or floor fatigue'],
            ['heel', 'Heel pressure', 'Hard-floor impact under heel'],
            ['arch', 'Arch fatigue', 'Support needed without closed shoes'],
            ['mixed', 'Mixed discomfort', 'Several signals across the day']
          ]
        },
        {
          key: 'context',
          title: 'Where does support matter most?',
          copy: 'This version separates home recovery from in-shoe structure.',
          options: [
            ['home', 'At home on hard floors', 'Recovery footwear first'],
            ['recovery', 'After activity', 'Lower-impact recovery support'],
            ['walking', 'Light outdoor walking', 'Footwear path first'],
            ['inside_shoes', 'Mostly work shoes', 'Likely insole-first']
          ]
        },
        {
          key: 'load',
          title: 'What kind of day are we matching?',
          copy: 'Long work shifts may still need in-shoe support.',
          options: [
            ['low', 'Mostly home or desk', 'Footwear-first path'],
            ['moderate', 'Moderate walking', 'Footwear or light support'],
            ['standing_all_day', 'Standing most of the day', 'May need in-shoe support first'],
            ['heavy_legs', 'Travel or heavy legs', 'Compression may be better add-on']
          ]
        }
      ]
    }
  };

  var state = {
    variant: runtime.initialContext || root.dataset.context || 'homepage_general',
    screen: 'intro',
    questionIndex: 0,
    answers: {},
    gender: 'men',
    size: '',
    result: null,
    deepUnlocked: false,
    deepAnswer: '',
    deepAnswers: {},
    deepIndex: 0,
    unlocked25Emitted: false,
    unlocked35Emitted: false,
    offerTimer: null
  };

  function $(selector) {
    return root.querySelector(selector);
  }

  function $$(selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function emit(name, detail) {
    detail = detail || {};
    var deviceType = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      var isEmbedded = root.dataset.mode === 'embedded';
      var eventPayload = Object.assign({
        event: name,
        event_category: isEmbedded ? 'lead_magnet' : 'quick_diagnostic_popup',
        event_source: isEmbedded ? 'quick_match_page' : 'quick_diagnostic_popup',
        event_label: detail.label || '',
        finder_version: state.variant,
        page_type: root.dataset.pageType || '',
        product_handle: root.dataset.productHandle || '',
        device_type: deviceType,
        discount_tier: detail.discount_tier || (state.deepUnlocked ? '35' : '25')
      }, detail);
      if (isEmbedded) {
        eventPayload.content_group = 'quick_match';
        eventPayload.template_name = 'page-quick-match-v2';
      }
      window.dataLayer.push(eventPayload);
    }
  }

  function activeConfig() {
    return configs[state.variant] || configs.homepage_general;
  }

  function activeMatchRules() {
    var rules = runtime.matchRules && (runtime.matchRules[state.variant] || runtime.matchRules.global);
    return Array.isArray(rules) && rules.length ? rules : defaults.matchRules;
  }

  function productConfig(key) {
    return Object.assign(
      {},
      defaults.products[key] || {},
      runtime.products && runtime.products[key] ? runtime.products[key] : {}
    );
  }

  function productHandleForKey(key) {
    var product = productConfig(key);
    if (product && product.handle) return String(product.handle);
    return String(key || '').replace(/_/g, '-');
  }

  function eligibilityConfig(key) {
    var runtimeEligibility = runtime.eligibility && runtime.eligibility[key] ? runtime.eligibility[key] : {};
    return Object.assign({}, defaults.eligibility[key] || {}, runtimeEligibility);
  }

  function showScreen(name) {
    state.screen = name;
    root.dataset.screen = name;
    $$('.vsf-screen').forEach(function (screen) {
      var active = screen.dataset.vsfScreen === name;
      screen.classList.toggle('is-active', active);
    });
    updateProgress();
  }

  function updateProgress() {
    var map = { auto_intro: 0, intro: 0, question: Math.min(3, state.questionIndex + 1), size: 4, matching: 4, result: 4, deep: 4, email: 4 };
    var current = map[state.screen] || 0;
    var fill = $('#vsfProgressFill');
    if (fill) fill.style.width = ((current / 4) * 100) + '%';
    $$('#vsfStepRail .vsf-step-pill').forEach(function (pill, idx) {
      var step = idx + 1;
      pill.classList.toggle('is-active', step === current && current < 4);
      pill.classList.toggle('is-done', step < current || current === 4);
    });
  }

  function optionLabelFor(key, value) {
    var question = activeConfig().questions.find(function (q) { return q.key === key; });
    if (!question) return value;
    var option = question.options.find(function (item) { return item[0] === value; });
    return option ? option[1] : value;
  }

  var deepQuestions = [
    {
      key: 'primary_goal',
      title: 'What matters most before checkout?',
      copy: 'This helps tighten the offer around your most important support signal.',
      options: [
        ['pain_relief', 'Fast pain relief', 'I want the most direct support path.'],
        ['comfort', 'All-day comfort', 'I need something I can wear longer.'],
        ['recovery', 'Recovery routine', 'I want lower-impact support after long days.']
      ]
    },
    {
      key: 'surface',
      title: 'Where does the problem show up most?',
      copy: 'Surface and shoe context help us confirm the product type.',
      options: [
        ['hard_floor', 'Hard floors', 'Home, kitchen, warehouse, or tile.'],
        ['closed_shoes', 'Closed shoes', 'Work shoes, sneakers, or boots.'],
        ['mixed', 'Mixed surfaces', 'It changes across the day.']
      ]
    },
    {
      key: 'checkout_intent',
      title: 'What would make this feel like a win today?',
      copy: 'Last signal. We will unlock the stronger fit code after this answer.',
      options: [
        ['best_offer', 'Best offer', 'I want the strongest code available.'],
        ['right_size', 'Right size confidence', 'I want less guessing before checkout.'],
        ['backup_plan', 'A backup path', 'I want to know what to try next if needed.']
      ]
    }
  ];

  function deepOptionLabelFor(key, value) {
    var question = deepQuestions.find(function (q) { return q.key === key; });
    if (!question) return value;
    var option = question.options.find(function (item) { return item[0] === value; });
    return option ? option[1] : value;
  }

  function renderDeepTrail() {
    var trail = $('#vsfDeepAnswerTrail');
    if (!trail) return;
    trail.innerHTML = Object.keys(state.deepAnswers).map(function (key) {
      return '<span class="vsf-answer-chip">' + deepOptionLabelFor(key, state.deepAnswers[key]) + '</span>';
    }).join('');
  }

  function renderDeepQuestion() {
    var question = deepQuestions[state.deepIndex];
    if (!question) return;
    var step = $('#vsfDeepStepCount');
    var title = $('#vsfDeepQuestionTitle');
    var copy = $('#vsfDeepQuestionCopy');
    var list = $('#vsfDeepOptionList');
    if (step) step.textContent = 'Final check ' + (state.deepIndex + 1) + ' of ' + deepQuestions.length;
    if (title) title.textContent = question.title;
    if (copy) copy.textContent = question.copy;
    renderDeepTrail();
    if (!list) return;
    list.innerHTML = '';
    question.options.forEach(function (row, index) {
      var selected = state.deepAnswers[question.key] === row[0];
      var button = document.createElement('button');
      button.className = 'vsf-option' + (selected ? ' is-selected' : '');
      button.type = 'button';
      button.style.setProperty('--vsf-index', index);
      button.innerHTML = '<span><strong>' + row[1] + '</strong><span>' + row[2] + '</span></span><span class="vsf-option-mark">' + (selected ? '\u2713' : '') + '</span>';
      button.addEventListener('click', function () {
        state.deepAnswers[question.key] = row[0];
        state.deepAnswer = row[0];
        emitAlias('qd_deep_step_answer', {
          label: question.key + ':' + row[0],
          step_index: state.deepIndex + 1,
          question_key: question.key,
          answer_value: row[0],
          answer_label: row[1]
        });
        if (state.deepIndex < deepQuestions.length - 1) {
          state.deepIndex += 1;
          renderDeepQuestion();
        } else {
          state.deepUnlocked = true;
          renderResult();
        }
      });
      list.appendChild(button);
    });
    showScreen('deep');
  }

  function renderAnswerTrail() {
    var trail = $('#vsfAnswerTrail');
    if (!trail) return;
    var html = Object.keys(state.answers).map(function (key) {
      return '<span class="vsf-answer-chip">' + optionLabelFor(key, state.answers[key]) + '</span>';
    }).join('');
    trail.innerHTML = html;
  }

  function renderQuestion() {
    var config = activeConfig();
    var question = config.questions[state.questionIndex];
    if (!question) return;
    $('#vsfStepCount').textContent = 'Step ' + (state.questionIndex + 1) + ' of 4';
    $('#vsfQuestionTitle').textContent = question.title;
    $('#vsfQuestionCopy').textContent = question.copy;
    renderAnswerTrail();
    var list = $('#vsfOptionList');
    list.innerHTML = '';
    question.options.forEach(function (row, index) {
      var selected = state.answers[question.key] === row[0];
      var button = document.createElement('button');
      button.className = 'vsf-option' + (selected ? ' is-selected' : '');
      button.type = 'button';
      button.style.setProperty('--vsf-index', index);
      button.innerHTML = '<span><strong>' + row[1] + '</strong><span>' + row[2] + '</span></span><span class="vsf-option-mark">' + (selected ? '\u2713' : '') + '</span>';
      button.addEventListener('click', function () {
        state.answers[question.key] = row[0];
        emit('vsf_step_answer', {
          label: question.key + ':' + row[0],
          step_index: state.questionIndex + 1,
          question_key: question.key,
          answer_value: row[0],
          answer_label: row[1]
        });
        emitAlias('qd_step_answer', {
          label: question.key + ':' + row[0],
          step_index: state.questionIndex + 1,
          question_key: question.key,
          answer_value: row[0],
          answer_label: row[1]
        });
        if (state.questionIndex < config.questions.length - 1) {
          state.questionIndex += 1;
          renderQuestion();
        } else {
          showScreen('size');
        }
      });
      list.appendChild(button);
    });
    showScreen('question');
  }

  function mapCurrentProductKey() {
    var handle = (activeConfig().currentProduct || '').toLowerCase();
    if (!handle) return '';
    if (handle.indexOf('heavy-duty') >= 0 || handle.indexOf('heavy_duty') >= 0) return 'heavy_duty';
    if (handle.indexOf('fascia-soothe') >= 0 || handle.indexOf('fascia_soothe') >= 0) return 'fascia_soothe';
    if (handle.indexOf('recovery-slide') >= 0 || handle.indexOf('recovery_slide') >= 0) return 'recovery_slide';
    if (handle.indexOf('propel-flip') >= 0 || handle.indexOf('propel_flip') >= 0) return 'propel_flip';
    if (handle.indexOf('compression') >= 0) return 'compression_max';
    return '';
  }

  function matchesRule(rule) {
    return Object.keys(rule.match || {}).every(function (key) {
      return state.answers[key] === rule.match[key];
    });
  }

  function uniquePush(list, value) {
    if (value && list.indexOf(value) < 0) list.push(value);
  }

  function buildCandidateKeys(sortedRules) {
    var keys = [];
    sortedRules.forEach(function (rule) {
      if (matchesRule(rule)) uniquePush(keys, rule.primary);
    });
    var currentKey = mapCurrentProductKey();
    if (currentKey) {
      if (state.variant === 'pdp_footwear' && ['home', 'recovery', 'walking'].indexOf(state.answers.context) >= 0) {
        uniquePush(keys, currentKey);
      }
      if (state.variant === 'pdp_insole' && state.answers.context !== 'home' && state.answers.context !== 'recovery') {
        uniquePush(keys, currentKey);
      }
    }
    defaults.fallbackOrder.forEach(function (key) { uniquePush(keys, key); });
    return keys;
  }

  function genderEligible(key) {
    var eligibility = eligibilityConfig(key);
    var allowed = Array.isArray(eligibility.genders) ? eligibility.genders : [];
    return !allowed.length || allowed.indexOf(state.gender) >= 0;
  }

  function productHasInventorySignal(product) {
    return Array.isArray(product.variants) && product.variants.length;
  }

  function candidateVariantId(product) {
    return findVariantForProduct(product, state.gender, state.size);
  }

  function sizeEligible(key, product) {
    if (!state.size) return true;
    var eligibility = eligibilityConfig(key);
    if (eligibility.sizeOptional) return true;
    if (productHasInventorySignal(product)) return !!candidateVariantId(product);
    if (state.gender === 'men' && eligibility.fallbackMinMen && eligibility.fallbackMaxMen) {
      var size = Number(state.size);
      return size >= Number(eligibility.fallbackMinMen) && size <= Number(eligibility.fallbackMaxMen);
    }
    return true;
  }

  function eligibilityReason(key, product) {
    if (!genderEligible(key)) return 'gender_ineligible';
    if (!sizeEligible(key, product)) return 'size_or_variant_unavailable';
    return '';
  }

  function chooseEligibleCandidate(sortedRules) {
    var candidates = buildCandidateKeys(sortedRules);
    var blocked = [];
    for (var i = 0; i < candidates.length; i += 1) {
      var key = candidates[i];
      var product = productConfig(key);
      if (!product || !product.name) continue;
      var reason = eligibilityReason(key, product);
      if (!reason) {
        if (blocked.length) {
          emit('vsf_recommendation_fallback', {
            label: key,
            selected_product: key,
            blocked_products: blocked.map(function (item) { return item.key + ':' + item.reason; }).join('|'),
            gender: state.gender,
            size: state.size
          });
        }
        return { key: key, product: product, blocked: blocked };
      }
      blocked.push({ key: key, reason: reason });
      emit('vsf_recommendation_filtered', {
        label: key,
        recommended_product: key,
        reason: reason,
        gender: state.gender,
        size: state.size
      });
    }
    var fallbackKey = 'heavy_duty';
    return { key: fallbackKey, product: productConfig(fallbackKey), blocked: blocked };
  }

  function tier2Config() {
    return runtime.couponTier2 || { enabled: true, code: 'VALSOLE35', label: '35% off $50+ orders unlocked' };
  }

  function tier1ProductCouponInfo(key) {
    var percent = 25;
    return {
      tier: String(percent),
      code: activeConfig().coupon || 'VALSOLE25',
      label: '25% off orders over $35',
      percent: percent
    };
  }

  function baseCouponCode() {
    var key = state.result && state.result.primaryKey ? state.result.primaryKey : mapCurrentProductKey();
    return tier1ProductCouponInfo(key).code;
  }

  function activeCouponInfo() {
    var key = state.result && state.result.primaryKey ? state.result.primaryKey : mapCurrentProductKey();
    var tier1 = tier1ProductCouponInfo(key);
    var tier2 = tier2Config();
    var tier2Code = tier2.code || 'VALSOLE35';
    var tier2Percent = 35;
    if (state.deepUnlocked && tier2.enabled !== false && tier2Code) {
      return {
        tier: String(tier2Percent),
        code: tier2Code,
        label: tier2.label || (tier2Percent + '% off $50+ orders unlocked'),
        percent: tier2Percent
      };
    }
    return tier1;
  }

  function emitAlias(name, detail) {
    emit(name, detail || {});
  }

  function renderWhyFit(result) {
    var list = $('#vsfWhyFitList');
    if (!list || !result) return;
    var rows = [
      'Matches your main pain pattern',
      'Built for your daily load',
      state.size ? 'Available in your selected size' : 'Size can be selected on product page'
    ];
    if (result.primary && result.primary.promo) {
      rows.push(result.primary.promo);
    }
    list.innerHTML = rows.slice(0, 4).map(function (text) {
      return '<span class="vsf-why-row"><span>✓</span>' + text + '</span>';
    }).join('');
  }

  function startOfferCountdown() {
    var wrap = $('#vsfOfferTimerWrap');
    var timer = $('#vsfOfferTimer');
    if (!wrap || !timer) return;
    wrap.hidden = false;
    if (state.offerTimer) window.clearInterval(state.offerTimer);
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      var ms = Math.max(0, end.getTime() - now.getTime());
      var total = Math.floor(ms / 1000);
      var h = String(Math.floor(total / 3600)).padStart(2, '0');
      var m = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
      var sec = String(total % 60).padStart(2, '0');
      timer.textContent = h + ':' + m + ':' + sec;
    }
    tick();
    state.offerTimer = window.setInterval(tick, 1000);
  }

  function computeResult() {
    var sorted = activeMatchRules().slice().sort(function (a, b) { return b.priority - a.priority; });
    var matched = sorted.find(matchesRule) || sorted[sorted.length - 1];
    var selected = chooseEligibleCandidate(sorted);
    var key = selected.key;
    var primary = selected.product;
    var currentKey = mapCurrentProductKey();
    var pageFitTitle = 'Current page fit';
    var pageFit = 'Your support match is ready. Open the recommended product to continue.';
    if (currentKey) {
      var currentProduct = productConfig(currentKey);
      var currentBlockedReason = eligibilityReason(currentKey, currentProduct);
      if (currentBlockedReason) {
        pageFitTitle = 'Current page fit issue';
        pageFit = state.gender === 'women'
          ? 'This product path is not the best first match for the selected women size path.'
          : 'This page may not have the selected size available, so we found a better fit.';
      } else if (currentKey === key) {
        pageFitTitle = 'Strong current-page fit';
        pageFit = 'You are already viewing the strongest match for this pattern.';
      } else {
        pageFitTitle = 'Better first match found';
        pageFit = 'This page can still help, but your first match is ' + primary.name + '.';
      }
    }
    var preferredBackups = primary.kind === 'footwear'
      ? ['heavy_duty', 'fascia_soothe', 'compression_max']
      : ['recovery_slide', 'propel_flip', 'fascia_soothe', 'compression_max'];
    var backupKey = preferredBackups.find(function (candidate) {
      return candidate !== key && !eligibilityReason(candidate, productConfig(candidate));
    }) || defaults.fallbackOrder.find(function (candidate) {
      return candidate !== key && !eligibilityReason(candidate, productConfig(candidate));
    }) || '';
    var backupProduct = productConfig(backupKey);
    return {
      primaryKey: key,
      primary: primary,
      backupProduct: backupProduct,
      confidence: key === matched.primary ? (matched.confidence || 'Medium') : 'Good',
      pageFitTitle: pageFitTitle,
      pageFit: pageFit,
      coupon: activeCouponInfo().code,
      blocked: selected.blocked || []
    };
  }

  function renderResult() {
    state.result = computeResult();
    var result = state.result;
    var couponInfo = activeCouponInfo();
    result.coupon = couponInfo.code;
    $('#vsfResultTitle').textContent = result.confidence + ' match found';
    $('#vsfConfidenceTag').textContent = result.confidence + ' fit';
    $('#vsfPrimaryName').textContent = result.primary.name || 'Recommended support';
    $('#vsfPrimaryReason').textContent = result.primary.reason || '';
    var primaryPromo = $('#vsfPrimaryPromo');
    if (primaryPromo) {
      if (result.primary.promo) {
        primaryPromo.textContent = result.primary.promo;
        primaryPromo.hidden = false;
      } else {
        primaryPromo.textContent = '';
        primaryPromo.hidden = true;
      }
    }
    var backupName = $('#vsfBackupName');
    if (backupName) backupName.textContent = result.backupProduct.name || 'Backup support';
    $('#vsfBackupCopy').textContent = result.primary.backup || result.backupProduct.reason || '';
    renderWhyFit(result);
    var backupLink = $('#vsfBackupLink');
    if (backupLink && result.backupProduct && result.backupProduct.url) {
      backupLink.href = result.backupProduct.url;
    }
    var img = $('#vsfResultImage');
    if (img) {
      if (result.primary.image) {
        img.onerror = function () {
          img.style.display = 'none';
          $('#vsfResultShape').style.display = 'block';
        };
        img.src = result.primary.image;
        img.alt = result.primary.name || 'Recommended product';
        img.style.display = 'block';
        $('#vsfResultShape').style.display = 'none';
      } else {
        img.removeAttribute('src');
        img.style.display = 'none';
        $('#vsfResultShape').style.display = 'block';
      }
    }
    $('#vsfDockCouponCode').textContent = result.coupon || '';
    var couponValue = $('#vsfDockCouponValue');
    if (couponValue) {
      couponValue.textContent = couponInfo.label;
    }
    var tier2Card = $('#vsfTier2Card');
    if (tier2Card) {
      var tier2 = tier2Config();
      var tier2Code = tier2.code || 'VALSOLE35';
      var tier2Percent = 35;
      tier2Card.hidden = !(tier2.enabled !== false && tier2Code && !state.deepUnlocked);
      var tier2Prompt = $('#vsfTier2Prompt');
      if (tier2Prompt) tier2Prompt.textContent = 'Complete the final check to unlock ' + tier2Percent + '% off $50+ orders.';
      var tier2Button = $('#vsfDeepQuizStart');
      if (tier2Button) tier2Button.textContent = 'Unlock ' + tier2Percent + '% off';
      var deepLabel = $('#vsfDeepUnlockLabel');
      if (deepLabel) deepLabel.textContent = tier2.label || (tier2Percent + '% off $50+ orders unlocked');
    }
    startOfferCountdown();
    if (!state.unlocked25Emitted) {
      state.unlocked25Emitted = true;
      emitAlias('qd_code_unlocked_25', { label: baseCouponCode(), discount_tier: '25', coupon_code: baseCouponCode() });
    }
    if (state.deepUnlocked && !state.unlocked35Emitted) {
      state.unlocked35Emitted = true;
      emitAlias('qd_code_unlocked_35', { label: couponInfo.code, discount_tier: '35', coupon_code: couponInfo.code });
    }
    $('#vsfResultShape').className = 'vsf-thumb-shape ' + (result.primary.kind || '');
    var addButton = $('#vsfAddRecommended');
    var canAdd = state.size && !!candidateVariantId(result.primary);
    if (addButton) {
      addButton.disabled = false;
      addButton.textContent = canAdd ? ('Add to cart + apply ' + couponInfo.tier + '%') : 'Choose size on product page';
      addButton.dataset.discountTier = couponInfo.tier;
      addButton.dataset.canAdd = canAdd ? 'true' : 'false';
    }
    $('#vsfCopyState').textContent = '';
    showScreen('result');
    emit('vsf_result_ready', { label: result.primaryKey, gender: state.gender, size: state.size, can_add: canAdd, discount_tier: couponInfo.tier });
    emitAlias('qd_result_view', { label: result.primaryKey, gender: state.gender, size: state.size, can_add: canAdd, discount_tier: couponInfo.tier, coupon_code: couponInfo.code });
  }

  function runMatching() {
    showScreen('matching');
    window.setTimeout(renderResult, 700);
  }

  function pickAutoIntroProduct() {
    var cfg = activeConfig();
    var candidates = [];
    if (cfg.currentProduct) candidates.push(cfg.currentProduct);
    if (state.variant === 'pdp_footwear') {
      candidates.push('recovery_slide', 'propel_flip', 'heavy_duty');
    } else if (state.variant === 'pdp_insole') {
      candidates.push('heavy_duty', 'fascia_soothe', 'recovery_slide');
    } else {
      candidates.push('heavy_duty', 'recovery_slide', 'fascia_soothe');
    }
    for (var i = 0; i < candidates.length; i += 1) {
      var product = productConfig(candidates[i]);
      if (product && product.image) return product;
    }
    return null;
  }

  function updateAutoIntroVisual() {
    var img = $('#vsfAutoVisualImage');
    if (!img) return;
    if (runtime.autoIntroHeroImage) {
      img.src = runtime.autoIntroHeroImage;
      img.alt = 'VALSOLE support finder';
      return;
    }
    var product = pickAutoIntroProduct();
    if (!product) {
      img.removeAttribute('src');
      img.removeAttribute('alt');
      return;
    }
    img.src = product.image;
    img.alt = product.name || 'Recommended VALSOLE support';
  }

  function updateAutoIntroCoupon() {
    var codeNode = $('#vsfAutoCouponCode');
    var stateNode = $('#vsfAutoCopyState');
    if (codeNode) codeNode.textContent = activeConfig().coupon || baseCouponCode();
    if (stateNode) stateNode.textContent = '';
  }

  function preloadAutoIntroImage() {
    var url = runtime.autoIntroHeroImage || '';
    if (!url) {
      var product = pickAutoIntroProduct();
      url = product && product.image ? product.image : '';
    }
    if (!url || window.__vsfAutoIntroImagePreloaded === url) return;
    window.__vsfAutoIntroImagePreloaded = url;
    var image = new Image();
    image.src = url;
  }

  function openFinder(options) {
    options = options || {};
    if (options.screen === 'auto_intro') {
      preloadAutoIntroImage();
      updateAutoIntroCoupon();
    }
    if (options.screen) showScreen(options.screen);
    if (root.dataset.mode === 'embedded') {
      var panel = $('#vsfPanel');
      if (panel) panel.setAttribute('aria-hidden', 'false');
      emit('vsf_open', { label: options.source || state.variant, source: options.source || 'quick_match_page', screen: state.screen });
      if (state.screen === 'intro' || state.screen === 'auto_intro') emitAlias('qd_intro_view', { label: state.variant, source: options.source || 'quick_match_page' });
      return;
    }
    document.body.classList.add('vsf-open');
    document.body.classList.add('vsf-finder-open');
    var panel = $('#vsfPanel');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    emit('vsf_open', { label: options.source || state.variant, source: options.source || 'manual', screen: state.screen });
    if (state.screen === 'intro' || state.screen === 'auto_intro') emitAlias('qd_intro_view', { label: state.variant, source: options.source || 'manual' });
  }

  function closeFinder() {
    if (root.dataset.mode === 'embedded') return;
    document.body.classList.remove('vsf-open');
    document.body.classList.remove('vsf-finder-open');
    var panel = $('#vsfPanel');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    emit('vsf_close', { label: state.variant });
    markAutoClosed();
  }

  function resetFlow(closePanel, startAtQuestion) {
    state.questionIndex = 0;
    state.answers = {};
    state.gender = 'men';
    state.size = '';
    state.result = null;
    state.deepUnlocked = false;
    state.deepAnswer = '';
    state.deepAnswers = {};
    state.deepIndex = 0;
    state.unlocked25Emitted = false;
    state.unlocked35Emitted = false;
    var sizeSelect = $('#vsfSizeSelect');
    if (sizeSelect) sizeSelect.value = '';
    $$('[data-vsf-gender]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.vsfGender === 'men');
    });
    if (startAtQuestion) {
      renderQuestion();
    } else {
      showScreen('intro');
    }
    if (closePanel) closeFinder();
  }

  function emailBonusConfig() {
    return runtime.emailBonus || {};
  }

  function emailMessage(key, fallback) {
    var config = emailBonusConfig();
    var value = config[key] || fallback || '';
    return String(value).replace('HELLOFRIEND', config.code || 'HELLOFRIEND');
  }

  function autoPopupConfig() {
    return runtime.autoPopup || {};
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return '';
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {}
  }

  function markAutoClosed() {
    var config = autoPopupConfig();
    if (config.suppressAfterClose && state.screen === 'auto_intro') {
      storageSet('vsf_auto_closed_at', String(Date.now()));
      emit('vsf_auto_popup_dismissed', { label: state.variant, source: 'close' });
    }
  }

  function autoDelaySeconds(config) {
    var type = root.dataset.pageType || '';
    if (type === 'index') return Number(config.homeDelaySeconds || 8);
    if (type === 'product') return Number(config.productDelaySeconds || 12);
    return Number(config.contentDelaySeconds || 14);
  }

  function autoPageEnabled(config) {
    var type = root.dataset.pageType || '';
    if (type === 'index') return !!config.homeEnabled;
    if (type === 'product') return !!config.productEnabled;
    return !!config.contentEnabled && ['article', 'blog', 'page'].indexOf(type) >= 0;
  }

  function shouldShowAutoPopup() {
    var config = autoPopupConfig();
    if (!config.enabled || !autoPageEnabled(config)) return false;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    if (isMobile && config.mobileEnabled === false) return false;
    if (!isMobile && config.desktopEnabled === false) return false;
    if (config.suppressAfterSignup && storageGet('vsf_newsletter_signed_up') === 'true') return false;
    var capDays = Math.max(1, Number(config.frequencyCapDays || 7));
    var capMs = capDays * 24 * 60 * 60 * 1000;
    var now = Date.now();
    var shownAt = Number(storageGet('vsf_auto_last_shown') || 0);
    if (shownAt && now - shownAt < capMs) return false;
    var closedAt = Number(storageGet('vsf_auto_closed_at') || 0);
    if (config.suppressAfterClose && closedAt && now - closedAt < capMs) return false;
    return true;
  }

  function scheduleAutoPopup() {
    if (root.dataset.mode === 'embedded') return;
    var config = autoPopupConfig();
    if (!shouldShowAutoPopup()) {
      emit('vsf_auto_popup_suppressed', { label: state.variant });
      return;
    }
    emit('vsf_auto_popup_eligible', { label: state.variant });
    window.setTimeout(function () {
      if (!shouldShowAutoPopup() || document.body.classList.contains('vsf-open')) return;
      preloadAutoIntroImage();
      storageSet('vsf_auto_last_shown', String(Date.now()));
      openFinder({ source: 'auto_popup', screen: 'auto_intro' });
      emit('vsf_auto_popup_shown', { label: state.variant, delay_seconds: autoDelaySeconds(config) });
    }, Math.max(0, autoDelaySeconds(config)) * 1000);
  }

  function ensureSubmitFrame(id, title) {
    var frame = document.getElementById(id);
    if (frame) return frame;
    frame = document.createElement('iframe');
    frame.id = id;
    frame.name = id;
    frame.hidden = true;
    frame.setAttribute('title', title || 'Newsletter signup');
    frame.setAttribute('aria-hidden', 'true');
    document.body.appendChild(frame);
    return frame;
  }

  function submitNativeNewsletterForm(form, frameId) {
    return new Promise(function (resolve, reject) {
      if (!form) {
        resolve({ skipped: true });
        return;
      }

      var frame = ensureSubmitFrame(frameId, 'Newsletter signup');
      var settled = false;
      var timer = null;

      function finish() {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        frame.removeEventListener('load', finish);
        resolve({ ok: true });
      }

      try {
        frame.addEventListener('load', finish);
        timer = window.setTimeout(finish, 1600);
        form.setAttribute('method', 'post');
        form.setAttribute('target', frameId);
        if (window.HTMLFormElement && window.HTMLFormElement.prototype.submit) {
          window.HTMLFormElement.prototype.submit.call(form);
        } else {
          form.submit();
        }
      } catch (error) {
        window.clearTimeout(timer);
        frame.removeEventListener('load', finish);
        reject(error);
      }
    });
  }

  function submitShopifyNewsletter(email) {
    if (!emailBonusConfig().shopifyCaptureEnabled) {
      return Promise.resolve({ skipped: true });
    }
    var form = $('#vsfEmailForm');
    var input = $('#vsfEmailInput');
    if (!form || !input) {
      return Promise.resolve({ skipped: true });
    }
    input.name = 'contact[email]';
    input.value = email;
    return submitNativeNewsletterForm(form, 'vsfNewsletterSubmitFrame');
  }

  function copyToClipboard(text, stateNode) {
    if (!text) return;
    var code = String(text).trim();
    if (!code) return;
    if (!stateNode) stateNode = { textContent: '' };

    function fallbackCopy(value) {
      try {
        var ta = document.createElement('textarea');
        ta.value = value;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        ta.style.pointerEvents = 'none';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        var ok = document.execCommand && document.execCommand('copy');
        document.body.removeChild(ta);
        return !!ok;
      } catch (error) {
        return false;
      }
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        stateNode.textContent = code + ' copied.';
        emit('vsf_coupon_copy', { label: code, coupon_code: code, screen: state.screen });
        emitAlias('qd_code_copy', { label: code, coupon_code: code, screen: state.screen, discount_tier: activeCouponInfo().tier });
      }).catch(function () {
        var copied = fallbackCopy(code);
        stateNode.textContent = copied ? (code + ' copied.') : ('Use code ' + code + ' at checkout.');
        emit('vsf_coupon_copy', { label: code, coupon_code: code, screen: state.screen, fallback: true, copied: copied });
        emitAlias('qd_code_copy', { label: code, coupon_code: code, screen: state.screen, fallback: true, copied: copied, discount_tier: activeCouponInfo().tier });
      });
      return;
    }
    var copiedFallback = fallbackCopy(code);
    stateNode.textContent = copiedFallback ? (code + ' copied.') : ('Use code ' + code + ' at checkout.');
    emit('vsf_coupon_copy', { label: code, coupon_code: code, screen: state.screen, fallback: true, copied: copiedFallback });
    emitAlias('qd_code_copy', { label: code, coupon_code: code, screen: state.screen, fallback: true, copied: copiedFallback, discount_tier: activeCouponInfo().tier });
  }

  function sizeInText(text, size) {
    var value = Number(size);
    if (!value || !text) return false;
    var escaped = String(size).replace('.', '\\.');
    var exact = new RegExp('(^|[^0-9.])' + escaped + '($|[^0-9.])');
    if (exact.test(text)) return true;
    var range;
    var rangeRe = /(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)/g;
    while ((range = rangeRe.exec(text)) !== null) {
      var min = Number(range[1]);
      var max = Number(range[2]);
      if (value >= Math.min(min, max) && value <= Math.max(min, max)) return true;
    }
    return false;
  }

  function sizeInGenderSegment(text, gender, size) {
    if (!text || !size) return false;
    var source = String(text).toLowerCase();
    var marker = gender === 'women' ? '(?:w|women|woman|female)' : '(?:m|men|man|male)';
    var re = new RegExp('(?:^|[\\s/,;|])(?:us\\s*)?' + marker + '\\s*([^/,;|]+)', 'g');
    var match;
    while ((match = re.exec(source)) !== null) {
      if (sizeInText(match[1], size)) return true;
    }
    return false;
  }

  function variantText(variant) {
    return String([variant.title].concat(variant.options || []).join(' ')).toLowerCase();
  }

  function configuredVariantId(product) {
    var id = product && product.variantId ? String(product.variantId).trim() : '';
    return /^\d+$/.test(id) ? id : '';
  }

  function findVariantForProduct(product, genderOverride, sizeOverride) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) return configuredVariantId(product);
    var size = Number(sizeOverride !== undefined ? sizeOverride : state.size);
    var gender = String(genderOverride !== undefined ? genderOverride : state.gender || '').toLowerCase();
    var convertedWomenToMen = gender === 'women' && size ? (size - 1.5) : null;
    var best = null;
    var bestScore = -1;
    variants.forEach(function (variant) {
      if (!variant || variant.available === false) return;
      var text = variantText(variant);
      var score = 0;
      if (size && sizeInGenderSegment(text, gender, size)) score += 80;
      if (convertedWomenToMen && sizeInGenderSegment(text, 'men', convertedWomenToMen)) score += 48;
      if (size && score === 0 && sizeInText(text, size)) score += 5;
      if (gender === 'women' && /\b(w|women|woman|female)\b/.test(text)) score += 3;
      if (gender === 'men' && /\b(m|men|man|male)\b/.test(text)) score += 3;
      if (!size && score === 0) score = 1;
      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    });
    if (best && (!size || bestScore >= 48)) return best.id;
    return !size ? configuredVariantId(product) : '';
  }

  function updateHeaderCountOptimistically(delta) {
    var amount = Number(delta) || 1;
    var nodes = document.querySelectorAll('.cart-count-bubble .count, [data-cart-count], .cart-count');
    nodes.forEach(function (node) {
      var current = Number(String(node.textContent || '').replace(/[^0-9]/g, '')) || 0;
      var next = current + amount;
      node.textContent = String(next);
      var bubble = node.closest && node.closest('.cart-count-bubble');
      if (bubble) bubble.classList.remove('hidden');
    });
  }

  function syncCartAfterAdd() {
    var now = Date.now();
    var nextReadSafeAt = now + 9000;
    var currentReadSafeAt = Number(window.__valsoleCartReadDeferredUntil || 0);
    window.__valsoleCartReadDeferredUntil = Math.max(currentReadSafeAt, nextReadSafeAt);
    var nextMutationSafeAt = now + 9000;
    var currentMutationSafeAt = Number(window.__valsoleCartMutationSoftBlockUntil || 0);
    window.__valsoleCartMutationSoftBlockUntil = Math.max(currentMutationSafeAt, nextMutationSafeAt);
    updateHeaderCountOptimistically(1);

    if (window.Valsole && window.Valsole.Cart) {
      if (typeof window.Valsole.Cart.open === 'function') {
        window.Valsole.Cart.open();
      }
      if (typeof window.Valsole.Cart.schedulePostAddSync === 'function') {
        window.Valsole.Cart.schedulePostAddSync({ delayMs: 9200 });
      }
    }
  }

  function scheduleDiscountApply(code, tier, feedback) {
    if (!code) return;
    storageSet('vsf_pending_discount_code', code);
    window.setTimeout(function () {
      var cart = window.Valsole && window.Valsole.Cart;
      if (cart && typeof cart.applyDiscountCode === 'function') {
        Promise.resolve(cart.applyDiscountCode(code)).then(function (ok) {
          if (ok === false) throw new Error('discount_apply_failed');
          if (feedback) feedback.textContent = 'Added to cart. Discount applied.';
          emitAlias('qd_discount_apply_success', { label: code, coupon_code: code, discount_tier: tier });
        }).catch(function () {
          copyToClipboard(code, feedback);
          if (feedback) feedback.textContent = 'Added to cart. Code copied for checkout: ' + code;
          emitAlias('qd_discount_apply_fail', { label: code, coupon_code: code, discount_tier: tier });
        });
        return;
      }
      copyToClipboard(code, feedback);
      if (feedback) feedback.textContent = 'Added to cart. Code copied for checkout: ' + code;
      emitAlias('qd_discount_apply_fail', { label: code, coupon_code: code, discount_tier: tier, reason: 'cart_api_unavailable' });
    }, 9800);
  }

  function addRecommended() {
    if (!state.result || !state.result.primary) return;
    var product = state.result.primary;
    var feedback = $('#vsfCopyState');
    var couponInfo = activeCouponInfo();
    var pendingToken = null;
    if ($('#vsfAddRecommended') && $('#vsfAddRecommended').dataset.canAdd === 'false') {
      viewDetails();
      return;
    }
    var variantId = findVariantForProduct(product);
    if (!variantId && runtime.isProductPage && product.handle === root.dataset.productHandle) {
      var select = document.querySelector('[data-pdp-sticky-atc-select]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (select && select.options && select.options.length) {
        if (state.size) {
          var target = (String(state.gender) + ' ' + String(state.size)).toLowerCase();
          for (var i = 0; i < select.options.length; i += 1) {
            var text = (select.options[i].textContent || '').toLowerCase();
            if (text.indexOf(target) >= 0 || sizeInGenderSegment(text, state.gender, state.size)) {
              variantId = select.options[i].value;
              break;
            }
          }
        }
        if (!variantId) variantId = select.value;
      }
    }
    if (!variantId) {
      if (state.size) {
        feedback.textContent = 'This size is currently unavailable. View product details to choose another size.';
      } else {
        feedback.textContent = 'Please choose a size first or view details to select on product page.';
      }
      emit('vsf_add_to_cart_error', {
        label: product.handle || product.name || '',
        reason: 'missing_variant',
        recommended_product: state.result.primaryKey,
        gender: state.gender,
        size: state.size
      });
      return;
    }
    feedback.textContent = 'Adding to cart + applying code...';
    emitAlias('qd_add_with_code_click', { label: product.handle || product.name || '', recommended_product: state.result.primaryKey, coupon_code: couponInfo.code, discount_tier: couponInfo.tier });
    emit('vsf_add_to_cart_attempt', {
      label: product.handle || product.name || '',
      recommended_product: state.result.primaryKey,
      variant_id: String(variantId),
      gender: state.gender,
      size: state.size
    });
    window.__valsoleUserAddIntentTs = Date.now();
    if (!window.__valsoleCartAddState) {
      window.__valsoleCartAddState = { inFlight: false, lastRun: 0 };
    }
    if (window.__valsoleCartAddState.inFlight || (Date.now() - window.__valsoleCartAddState.lastRun < 800)) {
      feedback.textContent = 'Already adding. Please wait a moment.';
      emit('vsf_add_to_cart_error', {
        label: product.handle || product.name || '',
        reason: 'duplicate_guard',
        recommended_product: state.result.primaryKey
      });
      return;
    }
    window.__valsoleCartAddState.inFlight = true;
    window.__valsoleCartAddState.lastRun = Date.now();
    if (
      window.Valsole &&
      window.Valsole.Cart &&
      typeof window.Valsole.Cart.beginExternalPending === 'function'
    ) {
      pendingToken = window.Valsole.Cart.beginExternalPending({
        type: 'item',
        message: 'Adding your matched item...',
        label: product.name || 'Adding matched item...'
      });
    }
    fetch('/cart/add.js?__valsole_mut=1', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Valsole-Cart-Allow-Mutation': '1'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(async function (response) {
      if (window.ValsoleCartChallenge) {
        var securityError = await window.ValsoleCartChallenge.responseError(response, 'quick_match', {
          items: [{ id: Number(variantId), quantity: 1 }]
        });
        if (securityError) throw securityError;
      }
      if (!response.ok) throw new Error('add_failed');
      return response.json();
    }).then(function () {
      feedback.textContent = 'Added. Opening cart + applying code...';
      emitAlias('qd_add_success', { label: product.handle || product.name || '', recommended_product: state.result.primaryKey, variant_id: String(variantId), coupon_code: couponInfo.code, discount_tier: couponInfo.tier });
      emit('vsf_add_to_cart_success', {
        label: product.handle || product.name || '',
        recommended_product: state.result.primaryKey,
        variant_id: String(variantId),
        gender: state.gender,
        size: state.size
      });
      syncCartAfterAdd();
      scheduleDiscountApply(couponInfo.code, couponInfo.tier, feedback);
      window.setTimeout(function () {
        closeFinder();
        if (window.Valsole && window.Valsole.Cart && typeof window.Valsole.Cart.open === 'function') {
          window.Valsole.Cart.open();
        } else {
          document.dispatchEvent(new CustomEvent('valsole:cart:open'));
        }
      }, 700);
      if (
        pendingToken &&
        window.Valsole &&
        window.Valsole.Cart &&
        typeof window.Valsole.Cart.endExternalPending === 'function'
      ) {
        window.setTimeout(function () {
          window.Valsole.Cart.endExternalPending(pendingToken, {
            success: true,
            successMessage: 'Cart updated'
          });
        }, 9600);
      }
    }).catch(function (error) {
      var securityRecoveryShown = window.ValsoleCartChallenge && window.ValsoleCartChallenge.show(error, {
        items: [{ id: Number(variantId), quantity: 1 }]
      });
      feedback.textContent = securityRecoveryShown
        ? 'Complete the security check to add your matched item.'
        : 'Unable to auto add. Open product page to select size.';
      emit('vsf_add_to_cart_error', {
        label: product.handle || product.name || '',
        reason: securityRecoveryShown ? 'security_challenge' : 'request_failed',
        recommended_product: state.result.primaryKey,
        variant_id: String(variantId)
      });
      if (
        pendingToken &&
        window.Valsole &&
        window.Valsole.Cart &&
        typeof window.Valsole.Cart.endExternalPending === 'function'
      ) {
        window.Valsole.Cart.endExternalPending(pendingToken, {
          success: false,
          errorMessage: 'Add to cart failed'
        });
      }
    }).finally(function () {
      if (window.__valsoleCartAddState) window.__valsoleCartAddState.inFlight = false;
      if (window.__valsoleUserAddIntentTs) window.__valsoleUserAddIntentTs = 0;
    });
  }

  function viewDetails() {
    if (!state.result || !state.result.primary) return;
    var rawUrl = state.result.primary.url || '/collections/insoles';
    try {
      var parsed = new URL(rawUrl, window.location.origin);
      if (state.size) parsed.searchParams.set('size', state.size);
      if (state.gender) parsed.searchParams.set('gender', state.gender);
      if (state.result.coupon) parsed.searchParams.set('discount', state.result.coupon);
      var isEmbedded = root.dataset.mode === 'embedded';
      parsed.searchParams.set('lm_source', isEmbedded ? 'quick_match_page' : (state.variant || 'quick_diagnostic'));
      window.location.href = parsed.pathname + parsed.search;
    } catch (error) {
      window.location.href = rawUrl;
    }
  }

  function enhanceSelect(select) {
    if (!select || select.dataset.vsfChoiceEnhanced === 'true') return;
    select.dataset.vsfChoiceEnhanced = 'true';
    select.classList.add('vsf-native-select--enhanced');
    var wrap = document.createElement('div');
    wrap.className = 'vsf-choice-select';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vsf-choice-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    var list = document.createElement('div');
    list.className = 'vsf-choice-select__list';
    list.setAttribute('role', 'listbox');
    wrap.appendChild(button);
    wrap.appendChild(list);
    select.insertAdjacentElement('afterend', wrap);

    function render() {
      var selected = select.options[select.selectedIndex];
      button.textContent = selected ? selected.textContent : 'Select';
      list.innerHTML = Array.prototype.map.call(select.options, function (option) {
        var active = option.value === select.value;
        return '<button type="button" role="option" class="vsf-choice-select__option' + (active ? ' is-selected' : '') + '"' +
          ' data-value="' + option.value + '"' +
          (option.disabled ? ' disabled' : '') +
          ' aria-selected="' + (active ? 'true' : 'false') + '">' +
          option.textContent +
          '</button>';
      }).join('');
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      wrap.classList.toggle('is-open');
      render();
      if (wrap.classList.contains('is-open')) {
        var rect = wrap.getBoundingClientRect();
        var spaceBelow = window.innerHeight - rect.bottom;
        var spaceAbove = rect.top;
        wrap.classList.toggle('is-drop-up', spaceBelow < 230 && spaceAbove > spaceBelow);
      }
    });
    list.addEventListener('click', function (event) {
      var option = event.target.closest('.vsf-choice-select__option');
      if (!option || option.disabled) return;
      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      wrap.classList.remove('is-open');
      render();
    });
    select.addEventListener('change', render);
    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) wrap.classList.remove('is-open');
    });
    render();
  }

  function applyVariant() {
    var cfg = activeConfig();
    $('#vsfVariantLabel').textContent = cfg.label;
    var labelNode = root.querySelector('.vsf-launcher-label') || document.querySelector('.pdp-sticky-atc__tools .vsf-launcher-label');
    if (labelNode) labelNode.textContent = cfg.launcher;
    $('#vsfHeading').textContent = cfg.introTitle;
    $('#vsfIntroCopy').textContent = cfg.introCopy;
    var emailConfig = emailBonusConfig();
    $('#vsfEmailBonusCode').textContent = emailConfig.code || 'HELLOFRIEND';
    var emailHeading = $('#vsfEmailHeading');
    var emailCopy = $('#vsfEmailCopy');
    var emailSubmit = $('#vsfEmailSubmit');
    if (emailHeading) emailHeading.textContent = emailConfig.heading || 'Join the list and unlock extra $5.';
    if (emailCopy) emailCopy.textContent = emailConfig.copy || 'Get VALSOLE updates and keep your bonus code for checkout.';
    if (emailSubmit) emailSubmit.textContent = emailConfig.buttonText || 'Sign up + unlock $5';
    if (!emailConfig || emailConfig.enabled === false) {
      var emailBtn = $('#vsfEmailResult');
      if (emailBtn) emailBtn.style.display = 'none';
    }
    updateAutoIntroVisual();
    enhanceSelect($('#vsfSizeSelect'));
    enhanceSelect(document.querySelector('[data-pdp-sticky-atc-select]'));
    resetFlow(false);
  }

  function bindNonPdpMobileFooterHide() {
    if (root.dataset.mode === 'embedded') return;
    if (runtime.isProductPage) return;

    var footerEl =
      document.querySelector('#shopify-section-sections--footer') ||
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('[id*="shopify-section-footer"]') ||
      document.querySelector('footer');
    var launcher = root.querySelector('.vsf-launcher');
    if (!footerEl || !launcher) return;

    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    var rafId = null;

    var shouldHideNearFooter = function () {
      if (mobileQuery && !mobileQuery.matches) return false;
      var footerRect = footerEl.getBoundingClientRect();
      if (footerRect.height <= 0) return false;

      var launcherHeight = Math.max(launcher.offsetHeight || 0, 48);
      var footerHideThreshold = launcherHeight + 36;
      return footerRect.top <= window.innerHeight - footerHideThreshold;
    };

    var syncVisibility = function () {
      rafId = null;
      root.dataset.hideLauncher = shouldHideNearFooter() ? 'true' : 'false';
    };

    var queueVisibilitySync = function () {
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(syncVisibility);
    };

    window.addEventListener('scroll', queueVisibilitySync, { passive: true });
    window.addEventListener('resize', queueVisibilitySync);
    window.addEventListener('orientationchange', queueVisibilitySync);
    if (mobileQuery && typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', queueVisibilitySync);
    } else if (mobileQuery && typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(queueVisibilitySync);
    }
    queueVisibilitySync();
  }

  function promotePdpDescriptionQuickMatchLinks() {
    if (!runtime.isProductPage) return;

    $$('.product-description a[href*="/pages/quick-match"]').forEach(function (node) {
      node.classList.add('js-open-quick-diagnostic');
      if (!node.dataset.qdSource) node.dataset.qdSource = 'pdp_description_quick_match';
      node.setAttribute('aria-haspopup', 'dialog');
    });
  }

  function openQuickDiagnosticFromTrigger(node, event) {
    if (!window.ValsoleSupportFinder || typeof window.ValsoleSupportFinder.open !== 'function') return;
    event.preventDefault();
    var source = node.dataset.qdSource || node.dataset.source || 'inline_link';
    emitAlias('qd_teaser_click', { label: state.variant, source: source });
    if (window.Valsole && window.Valsole.Cart && typeof window.Valsole.Cart.close === 'function') {
      window.Valsole.Cart.close();
    }
    var newsletterPopup = document.getElementById('newsletter-popup-valsole');
    if (newsletterPopup) {
      newsletterPopup.style.display = 'none';
      newsletterPopup.style.opacity = '0';
      newsletterPopup.setAttribute('aria-hidden', 'true');
    }
    resetFlow(false, false);
    openFinder({ source: source });
  }

  function bind() {
    var hideLauncher = runtime.isProductPage && runtime.showOnProduct === false;
    root.dataset.hideLauncher = hideLauncher ? 'true' : 'false';
    if (runtime.isProductPage) {
      root.dataset.position = 'pdp_atc';
    } else {
      root.dataset.position = 'left';
    }

    var launcher = root.querySelector('.vsf-launcher');
    var stickyBar = document.querySelector('[data-pdp-sticky-atc]');
    var stickyTools = stickyBar ? stickyBar.querySelector('[data-pdp-sticky-atc-tools]') : null;
    var dockPdpLauncher = function () {
      if (root.dataset.mode === 'embedded') return;
      if (!launcher || !runtime.isProductPage || !stickyTools) return;
      root.dataset.docked = 'pdp-sticky';
      launcher.classList.add('vsf-launcher--sticky');
      launcher.style.removeProperty('left');
      launcher.style.removeProperty('top');
      launcher.style.removeProperty('right');
      launcher.style.removeProperty('bottom');
      launcher.style.removeProperty('transform');
      if (launcher.parentElement !== stickyTools) {
        stickyTools.appendChild(launcher);
      }
    };
    dockPdpLauncher();
    window.addEventListener('resize', dockPdpLauncher);
    bindNonPdpMobileFooterHide();
    window.requestAnimationFrame(function () {
      root.classList.add('is-ready');
      if (root.dataset.mode !== 'embedded') {
        emitAlias('qd_teaser_view', { label: state.variant, source: runtime.isProductPage ? 'pdp_sticky' : 'side_teaser' });
      }
    });

    if (launcher) {
      launcher.addEventListener('click', function () {
        emitAlias('qd_teaser_click', { label: state.variant, source: 'manual_teaser' });
        resetFlow(false, false);
        openFinder({ source: 'manual_teaser' });
      });
    }
    promotePdpDescriptionQuickMatchLinks();
    $$('.js-open-quick-diagnostic').forEach(function (node) {
      if (node.dataset.vsfOpenBound === 'true') return;
      node.dataset.vsfOpenBound = 'true';
      node.addEventListener('click', function (event) {
        openQuickDiagnosticFromTrigger(node, event);
      });
    });
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || !event.target || typeof event.target.closest !== 'function') return;
      var node = event.target.closest('.js-open-quick-diagnostic, .product-description a[href*="/pages/quick-match"]');
      if (!node) return;
      if (node.matches('.product-description a[href*="/pages/quick-match"]')) {
        node.classList.add('js-open-quick-diagnostic');
        if (!node.dataset.qdSource) node.dataset.qdSource = 'pdp_description_quick_match';
        node.setAttribute('aria-haspopup', 'dialog');
      }
      openQuickDiagnosticFromTrigger(node, event);
    });
    $$('[data-vsf-close]').forEach(function (node) {
      node.addEventListener('click', closeFinder);
    });

    var start = $('#vsfStartFlow');
    if (start) start.addEventListener('click', function () { state.questionIndex = 0; emitAlias('qd_quiz_start', { label: state.variant }); renderQuestion(); });
    var autoStart = $('#vsfAutoStartFlow');
    if (autoStart) {
      autoStart.addEventListener('click', function () {
        emit('vsf_auto_popup_start', { label: state.variant });
        resetFlow(false, true);
      });
    }
    var autoDismiss = $('#vsfAutoDismiss');
    if (autoDismiss) {
      autoDismiss.addEventListener('click', function () {
        emit('vsf_auto_popup_dismissed', { label: state.variant, source: 'dismiss_button' });
        closeFinder();
      });
    }
    var autoCopy = $('#vsfAutoCopyCoupon');
    if (autoCopy) {
      autoCopy.addEventListener('click', function () {
        var codeNode = $('#vsfAutoCouponCode');
        var stateNode = $('#vsfAutoCopyState');
        copyToClipboard(codeNode ? codeNode.textContent : baseCouponCode(), stateNode);
        autoCopy.classList.add('is-copied');
        window.setTimeout(function () {
          autoCopy.classList.remove('is-copied');
        }, 1600);
      });
    }
    var restart = $('#vsfRestartFlow');
    if (restart) {
      restart.addEventListener('click', function () {
        resetFlow(false, true);
        emit('vsf_restart', { label: state.variant });
      });
    }
    var back = $('#vsfBackStep');
    if (back) {
      back.addEventListener('click', function () {
        if (state.questionIndex > 0) {
          state.questionIndex -= 1;
          renderQuestion();
        } else {
          showScreen('intro');
        }
      });
    }
    var backFromSize = $('#vsfBackFromSize');
    if (backFromSize) {
      backFromSize.addEventListener('click', function () {
        state.questionIndex = Math.max(0, activeConfig().questions.length - 1);
        renderQuestion();
      });
    }

    $('#vsfSkipSize').addEventListener('click', function () {
      state.size = '';
      emit('vsf_size_skipped', { label: state.variant });
      runMatching();
    });
    $('#vsfFinishWithSize').addEventListener('click', function () {
      state.size = $('#vsfSizeSelect').value;
      emit('vsf_size_selected', { label: state.gender + ':' + state.size, gender: state.gender, size: state.size });
      runMatching();
    });
    $$('[data-vsf-gender]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.gender = btn.dataset.vsfGender;
        $$('[data-vsf-gender]').forEach(function (each) { each.classList.toggle('is-active', each === btn); });
      });
    });

    $('#vsfDockCopyCoupon').addEventListener('click', function () {
      copyToClipboard($('#vsfDockCouponCode').textContent, $('#vsfCopyState'));
    });
    var emailCopy = $('#vsfEmailCopyBonus');
    if (emailCopy) {
      emailCopy.addEventListener('click', function () {
        copyToClipboard($('#vsfEmailBonusCode').textContent, $('#vsfEmailCopyState'));
      });
    }
    $('#vsfAddRecommended').addEventListener('click', addRecommended);
    $('#vsfViewDetails').addEventListener('click', viewDetails);
    var deepStart = $('#vsfDeepQuizStart');
    if (deepStart) {
      deepStart.addEventListener('click', function () {
        state.deepIndex = 0;
        state.deepAnswers = {};
        renderDeepQuestion();
        emitAlias('qd_deep_quiz_start', { label: state.result && state.result.primaryKey ? state.result.primaryKey : state.variant });
      });
    }
    var backFromDeep = $('#vsfBackFromDeep');
    if (backFromDeep) backFromDeep.addEventListener('click', function () { showScreen('result'); });

    $('#vsfEmailResult').addEventListener('click', function () {
      showScreen('email');
      emit('vsf_email_step_view', { label: state.result && state.result.primaryKey ? state.result.primaryKey : state.variant });
    });
    $('#vsfBackToResult').addEventListener('click', function () { showScreen('result'); });

    $('#vsfEmailForm').addEventListener('submit', function () {
      var email = $('#vsfEmailInput').value.trim();
      if (!email) return;
      var submit = $('#vsfEmailSubmit');
      var stateNode = $('#vsfEmailState');
      if (submit) submit.disabled = true;
      if (stateNode) stateNode.textContent = 'Submitting through Shopify...';
      storageSet('vsf_newsletter_pending', 'true');
      storageSet('vsf_newsletter_pending_source', 'quick_diagnostic');
      storageSet('valsole_newsletter_pending', 'true');
      storageSet('valsole_newsletter_pending_source', 'quick_diagnostic');
      storageSet('vsf_last_email', email);
      emit('vsf_email_intent', { label: state.variant });
      emit('vsf_email_submit', { label: state.variant });
      emitAlias('newsletter_submit', { label: 'quick_diagnostic', source: 'quick_diagnostic' });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeFinder();
    });
  }

  bind();
  applyVariant();
  preloadAutoIntroImage();
  if (root.dataset.mode === 'embedded') {
    resetFlow(false, false);
    openFinder({ source: 'quick_match_page' });
  } else {
    scheduleAutoPopup();
  }

  window.ValsoleSupportFinder = window.ValsoleSupportFinder || {};
  window.ValsoleSupportFinder.open = openFinder;
  window.ValsoleSupportFinder.close = closeFinder;
})();
